import React from "react";
import { Construction } from "lucide-react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import PublicLayout from "./PublicLayout";

function Card() {
    return (
        <div style={{
            display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
            textAlign: "center", padding: "48px 24px", minHeight: 360,
        }}>
            <div style={{
                width: 72, height: 72, borderRadius: 18, background: "var(--accent-soft)",
                display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 20,
            }}>
                <Construction size={34} color="var(--brand-text)" />
            </div>
            <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: "var(--brand-text)" }}>
                Under Construction
            </h1>
            <p style={{ margin: "10px 0 0", fontSize: 14, color: "var(--ink-500)", maxWidth: 380, lineHeight: 1.6 }}>
                This section is temporarily unavailable while we make some improvements.
                Please check back soon.
            </p>
        </div>
    );
}

/**
 * Shown in place of a section that an admin has disabled.
 *  - variant "app" (default): rendered inside the authenticated app shell
 *    (sidebar + header) so the user can navigate elsewhere.
 *  - variant "public": rendered inside PublicLayout, which adapts to the
 *    logged-in/logged-out chrome for public-facing pages.
 */
export default function UnderConstruction({ variant = "app" }) {
    if (variant === "public") {
        return (
            <PublicLayout activePage="">
                <Card />
            </PublicLayout>
        );
    }
    return (
        <div className="home-layout">
            <Sidebar activePage="" />
            <main className="home-main">
                <Header />
                <div className="home-content">
                    <Card />
                </div>
            </main>
        </div>
    );
}
